import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FormStyles.css';
import Logo from './logo/hirefly-logo.png';

const RoleSelection = () => {
  const navigate = useNavigate();

  const handleRoleSelection = (role) => {
    // Here you would typically update the user's role in your database
    // For now, we'll just navigate to the appropriate setup page
    if (role === 'employee') {
      navigate('/employee-setup');
    } else {
      navigate('/employer-setup');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo-section">
            <img src={Logo} alt="Hirefly Logo" className="logo" />
            <h1 className="hirefly-text">Hirefly</h1>
          </div>
        </div>

        <div className="role-selection">
          <button 
            className="role-btn employee-btn"
            onClick={() => handleRoleSelection('employee')}
          >
            <div className="role-content">
              <span className="role-icon">👨‍💼</span>
              <span className="role-title">I'm Looking for a Job</span>
              <span className="role-description">Find your next opportunity</span>
            </div>
          </button>
          <button 
            className="role-btn employer-btn"
            onClick={() => handleRoleSelection('employer')}
          >
            <div className="role-content">
              <span className="role-icon">🏢</span>
              <span className="role-title">I'm Hiring</span>
              <span className="role-description">Post jobs and find talent</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;
